import { FaFacebook, FaInstagram, FaYelp } from "react-icons/fa";

const socialLinks = [
  {
    href: "https://www.yelp.com/biz/alo-asian-kitchen-laguna-niguel",
    label: "Visit our Yelp page",
    icon: FaYelp,
  },
  {
    href: "https://www.facebook.com/ALOASIANKITCHENLN/",
    label: "Visit our Facebook page",
    icon: FaFacebook,
  },
  {
    href: "https://www.instagram.com/aloasiankitchen/",
    label: "Visit our Instagram page",
    icon: FaInstagram,
  },
];

function SocialIcons() {
  return (
    <div className="d-flex gap-3">
      {socialLinks.map(({ href, label, icon: Icon }) => (
        <a
          key={href}
          className="social-icon"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
        >
          <Icon size={24} />
        </a>
      ))}
    </div>
  );
}

export default SocialIcons;